export const API_CACHE_PREFIX = 'patchbay-api-v2:'
export const LEGACY_API_CACHE = 'patchbay-api'
export const API_CACHE_MAX_AGE_SECONDS = 60 * 60 * 24 * 2
export const API_CACHE_MAX_ENTRIES = 300

export type OfflineCacheMessage =
  | { type: 'patchbay:cache-user'; userId: string }
  | { type: 'patchbay:cache-clear'; reason: 'sign-out' | 'unauthorized' | 'user-changed' }

export function offlineCacheName(userId: string): string {
  const id = userId.trim()
  if (!id) throw new Error('offline cache user id is required')
  return `${API_CACHE_PREFIX}${encodeURIComponent(id)}`
}

export function isCacheableApiRequest(request: Request, appOrigin: string = globalThis.location?.origin ?? ''): boolean {
  if (request.method !== 'GET') return false
  const url = new URL(request.url, appOrigin || 'http://patchbay.invalid')
  if (appOrigin && url.origin !== appOrigin) return false
  if (!url.pathname.startsWith('/api/v1/')) return false
  if (url.pathname.startsWith('/api/v1/auth/')) return false
  if (url.pathname.startsWith('/api/v1/portal/')) return false
  if (url.pathname.startsWith('/api/v1/help/')) return false
  if (url.pathname.startsWith('/api/v1/satisfaction/public')) return false
  if (url.pathname === '/api/v1/stream' || url.pathname.endsWith('.csv')) return false
  return true
}
